import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Pagination } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LanguageIcon from "@mui/icons-material/Language";
import Details from "./Details";
import ModalForVoiceAgent from "./ModalForVoiceAgent";
import CommonMoreActionOptionModal from "./CommonMoreActionOptionModal";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DoDisturbAltIcon from "@mui/icons-material/DoDisturbAlt";
import CallIcon from "@mui/icons-material/Call";
import WifiCalling3Icon from "@mui/icons-material/WifiCalling3";
import { DeleteVoiceAgentForCallingAgent, getVoiceAgentForCalligAgent, getVoiceAgentPersonaForCallingAgent } from "../../../../../contexts/WorkspaceUtils";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CommanModalForConformation from "../../../../Common_Components/CommanModalForConformation";
import CommonToast from "../../../../Common_Components/CommonToast";
import VoiceCallOptionModal from "./VoiceCallOptionModal";
import { useWorkspace } from "../../../../../contexts/WorkspaceContext";
import CircularLoader from "../../Track_Website/CircularLoader";

const VoiceAgents = () => {
  const [openAddVoiceAgentModal, setopenAddVoiceAgentModal] = useState(null);
  const [openUserDetails, setopenUserDetails] = useState(null);
  const [moreActionOption, setMoreActionOption] = useState(null);
  const [openDeleteConformationModal, setOpenDeleteConformationModal] = useState(false);
  const [deleteModalTitle, setDeleteModalTitle] = useState("Delete Voice agent?");
  const [deleteModalMsg, setDeleteModalMsg] = useState("This Voice agent will be deleted and removed from this list. This action cannot be undone. Are you sure you want to delete this Voice agent?");
  const [activeUserObject, setActiveUserObject] = useState(null);
  const [voiceAgentData, setVoiceAgentData] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(null);
  const [toastopen, setToastopen] = useState(false);
  const [content, setContent] = useState("");
  const [iconType, setIconType] = useState('success');
  const [loading, setLoading] = useState(false);
  const [userID, setUserID] = useState("");
  const {showVoiceCallModal} = useWorkspace()


    const theme = createTheme({
        typography: {
          fontFamily: "Inter",
        },
        components: {
          MuiPagination: {
            styleOverrides: {
              root: {
                "& .MuiPaginationItem-root": {
                  color: "#ffffff",
                  borderRadius: "20px",
                  "&:hover": {
                    backgroundColor: "rgba(179, 168, 183, 0.26)",
                  },
                  fontSize: "14px",
                },
                "& .MuiPaginationItem-page.Mui-selected": {
                  backgroundColor: "#CAC4D0",
                  color: "black",
                  "&:hover": {
                    backgroundColor: "#CAC4D0",
                  },
                },
                "& .MuiPaginationItem-ellipsis": {
                  color: "#ffffff",
                },
                "& .MuiPaginationItem-previousNext": {
                  color: "#ffffff",
                  borderRadius: "20px",
                },
              },
            },
          },
        },
      });
  

  const Defaultoption = [
    {
      label: "Edit",
      icon: <EditIcon style={{ color: "white" }} />,
      onClick: () => console.log("Edit"),
    },
    {
      label: "Voice call",
      icon: <CallIcon style={{ color: "white" }} />,
      onClick: () => console.log("Voice call"),
    },
    {
      label: "Web call",
      icon: <WifiCalling3Icon style={{ color: "white" }} />,
      onClick: () => console.log("Web call "),
    },
    {
      label: "Blocklist",
      icon: <DoDisturbAltIcon style={{ color: "white" }} />,
      onClick: () => console.log("Blocklist"),
    },
    {
      label: "Delete",
      icon: <DeleteIcon style={{ color: "white" }} />,
      onClick: () => console.log("Delete"),
    },
  ];

    const GetVoiceAgentData = async () =>{
      setLoading(true)
      try{
        const res = await getVoiceAgentForCalligAgent(currentPage);
        const voiceAgentData = await res?.json();
        if(voiceAgentData?.status){
            // console.log("voiceAgentData",voiceAgentData?.data)
            setVoiceAgentData(voiceAgentData?.data?.data)
            setTotalPages(voiceAgentData?.data?.pagination?.total_pages)
        }else{
          setToastopen(true);
          setContent(voiceAgentData?.message);
          setIconType('error');
        }
      }catch(error){
        console.log(error)
        setToastopen(true);
        setContent(error?.message);
        setIconType('error');
      }
      setLoading(false)
    }
  
    useEffect(()=>{
      GetVoiceAgentData()
    },[currentPage])

  const data = [
    {
      Label: "Emma",
      slable: "voiceagents-1ae19ad7-c4f3-4c0e-a632-000c4aad6e0d",
      Type: "Phone call",
      Language: "cam@sharewise.io",
      Persona: "+16474772056",
      LLM: "Emma - Mortgage",
      Updated: "3/20/2025 11:00PM",
      Actions: "all",
    },
    {
      Label: "Agent Vic",
      slable: "voiceagents-1ae19ad7-c4f3-4c0e-a632-000c4aad6e0d",
      Type: "Web Call",
      Language: "cam@sharewise.io",
      Persona: "+16474772056",
      LLM: "VIC",
      Updated: "3/20/2025 11:00PM",
      Actions: "all",
    },
    {
      Label: "Ryan",
      slable: "voiceagents-1ae19ad7-c4f3-4c0e-a632-000c4aad6e0d",
      Type: "Phone call",
      Language: "cam@sharewise.io",
      Persona: "+16474772056",
      LLM: "Real Estate Specialist",
      Updated: "3/20/2025 11:00PM",
      Actions: "all",
    },
  ];

  const HandleCloseButtonClick = () => {
    setActiveUserObject(null)
    setopenAddVoiceAgentModal(false);
  };

  const HandleAddVoiceAgentButtonClick = () => {
    setopenAddVoiceAgentModal(true);
  };

  const HandleMoreOptionButtonClick =  (event, object) => {
    event.stopPropagation();
    // setMoreActionOption(true)
    setActiveUserObject(object)
    setMoreActionOption(event.currentTarget); // Get button element
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleToastClose = () => {
    setToastopen(false)
  }

  
    const HandleCancelDeleteVoiceAgent =async () =>{
        setOpenDeleteConformationModal(false)
    }
  
    const HandleConfirmDeleteVoiceAgent = async () =>{
      setOpenDeleteConformationModal(false)
      setMoreActionOption(false)
      try{
        const jsonRespData = await DeleteVoiceAgentForCallingAgent(activeUserObject?.id)
        const response = await jsonRespData.json()
        if(response?.status){
          setToastopen(true);
          setContent(response?.message);
          setIconType('success');
           setActiveUserObject(null)
          await GetVoiceAgentData()
      }else{
        setToastopen(true);
        setContent(response?.message);
        setIconType('error');
      }
      }catch(error){
        console.log(error)
        setToastopen(true);
        setContent(error?.message);
        setIconType('error');
      }
    }

    function formatDateTime(isoString) {
      const date = new Date(isoString);
    
      const day = date.getDate();
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
    
      let hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
    
      hours = hours % 12;
      hours = hours ? hours : 12; // 0 should be 12
    
      return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
    }

  return (
    <>
      {openUserDetails ? (
        <Details
          name={userID?.label}
          id={userID?.id}
          setopenUserDetails={setopenUserDetails}
          place={"voiceAgent"}
        />
      ) : (
        <div style={{ position: "relative" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h4" sx={{fontFamily:"Inter", fontSize:"24px", fontStyle:"normal", fontWeight:600, lineHeight:"20px", color:"#ffffff", opacity:0.90}}>Voice Agents</Typography>
            <Box
              sx={{ display: "flex", flexDirection: "row", columnGap: "20px" }}
            >
              { !voiceAgentData &&  <Button
                onClick={HandleAddVoiceAgentButtonClick}
                sx={{
                  width: "120px",
                  maxWidth: "120px",
                  height: "40px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 600,
                  textAlign: "center",
                  bgcolor: "rgba(246, 190, 107, 1)",
                  color: "rgba(23, 24, 44, 1)",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#ffd9aa",
                  },
                  // "&.Mui-disabled": {
                  //   color: "rgba(230, 224, 233, 1)", // Custom color for the disabled state
                  //   bgcolor:(subscribe && subscribeType === 4) ? "rgba(230, 224, 233, 0.12)" : "rgba(40, 45, 81, 1)"
                  // },
                }}
              >
                Add agent
              </Button> }
            </Box>
          </Box>
          {/* Contacts content goes here */}
          <Box
            sx={{
              border: "1px solid rgba(255, 255, 255, 0.10)",
              display: "flex",
              flexDirection: "column",
              width: "100%",
              backgroundColor: "#171A2D",
              marginTop: "40px",
              padding: "20px",
              borderRadius: "16px",
              maxHeight:"950px",
              overflowY:"auto"
            }}
          >
            <Box>
            {
                  loading ? 
                 <CircularLoader  msg={"Loading VoiceAgents..."} /> 
                :
              <TableContainer>
                <Table sx={{ fontFamily: "Inter", color: "#ffffff" }}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Label
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Type
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Language
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Persona
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        LLM Agent
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Updated at
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {voiceAgentData?.map((row, index) => (
                      <TableRow
                        onClick={() => {
                          setopenUserDetails(true); setUserID(row)
                        }}
                        key={row.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          cursor: "pointer",
                        }}
                      >
                        <Box sx={{border:"", maxWidth:"500px"}}>
                          <TableCell
                            align="left"
                            sx={{
                              fontFamily: "Inter",
                              color: "#ffffff",
                              padding: "20px 24px",
                              borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                              minWidth:"300px"
                            }}
                          >
                            <Box sx={{border:"", maxWidth:"250px", fontFamily:"Inter", fontSize:"16px", fontStyle:"normal", fontWeight:600, lineHeight:"28px", color:"#CAC4D0", '&:hover':{color:"#CAC4D0", opacity:0.8}}}>
                            {row?.label}
                            </Box>
                            <spam
                              style={{ color: "rgba(255, 255, 255, 0.60)",border:"", }}>
                              {row?.voice_agent_id}
                            </spam>
                          </TableCell>
                        </Box>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              columnGap: "10px",
                              width: "120px",
                              height: "36px",
                              backgroundColor: "#1F233E",
                              padding: "6px",
                              borderRadius: "8px",
                              alignItems: "center",
                              justifyContent: "center",
                              border:""
                            }}
                          >
                            <Box sx={{}}>
                              {row?.type === "web_call" ? (
                                <LanguageIcon
                                  width="16px"
                                  height="16px"
                                  sx={{ color: "#CAC4D0" }}
                                />
                              ) : (
                                <LocalPhoneIcon
                                  width="16px"
                                  height="16px"
                                  sx={{ color: "#CAC4D0" }}
                                />
                              )}
                            </Box>
                            <Box
                              sx={{
                                fontFamily: "Inter",
                                color: "#ffffff",
                                fontSize: "14px",
                              }}
                            >
                              {row.type === "web_call" ? "Web Call" : "Phone Call" }
                            </Box>
                          </Box>
                          <Box sx={{border:"",  width: "120px", display:"flex", alignItems:"center", justifyContent:"center", marginTop:"8px"}}>
                          <Typography sx={{fontFamily:"Inter", fontSize:"12px", fontStyle:"normal", fontWeight:400, lineHeight:"18px", color:"rgba(255, 255, 255, 0.60)"}}> {row.phone_number}</Typography>
                          </Box>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          {row?.language}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          {row?.voice_persona}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          {row.llm_agent}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                           {formatDateTime(row.updated_at)}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          <Box>
                            <Button
                              onClick={(e)=>HandleMoreOptionButtonClick(e, row)}
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                borderRadius: "50%",
                                alignItems: "center",
                                maxWidth: "36px",
                                minWidth: "36px",
                                height: "36px",
                                bgcolor: "#1F233E",
                                padding: "8px",
                              }}
                            >
                              <MoreVertOutlinedIcon
                                sx={{
                                  color: "#CAC4D0",
                                  width: "20px",
                                  height: "20px",
                                  bgcolor: "#1F233E",
                                }}
                              />
                            </Button>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            }
            </Box>
          </Box>
           {/* <div className="d-flex justify-content-center mt-3">
                          <ThemeProvider theme={theme}>
                            <Pagination
                              count={totalPages} // Total number of pages
                              page={currentPage} // Current page
                              siblingCount={1} // Show one previous and one upcoming page
                              boundaryCount={1} // Show first and last page buttons
                              onChange={handlePageChange} // Handle page change
                              shape="rounded" // Rounded buttons
                              size="large" // Larger buttons
                            />
                          </ThemeProvider>
                        </div> */}
          {<ModalForVoiceAgent
            openAddVoiceAgentModal={openAddVoiceAgentModal}
            setopenAddVoiceAgentModal={setopenAddVoiceAgentModal}
            HandleCloseButtonClick={HandleCloseButtonClick}
            fetchData={GetVoiceAgentData}
            activeUserObject={activeUserObject}
            setMoreActionOption={setMoreActionOption}
          />}
          <CommonMoreActionOptionModal
            showModal={moreActionOption}
            setShowModal={setMoreActionOption}
            options={Defaultoption}
            setOpenDeleteConformationModal={setOpenDeleteConformationModal}
            openEditedModal={setopenAddVoiceAgentModal}
            setActiveUserObject={setActiveUserObject}
            activeUserObject={activeUserObject}
          />
           <CommanModalForConformation open={openDeleteConformationModal} modalTitle={deleteModalTitle} modalMessage={deleteModalMsg} handleConfirm={HandleConfirmDeleteVoiceAgent} handleCancel={HandleCancelDeleteVoiceAgent}/>
           <CommonToast  open={toastopen} onClose={handleToastClose} content={content} iconType={iconType} bgColor={"#282D51"}/>
           {showVoiceCallModal && <VoiceCallOptionModal activeUserObject={activeUserObject} setActiveUserObject={setActiveUserObject}/>}
        </div>
      )}
    </>
  );
};

export default VoiceAgents;
